import ArrayPrimitiveCustomTextAttributeRenderer from "./ArrayPrimitiveCustomTextAttributeRenderer.js";
import CustomTextAttributeEditor from "./CustomTextAttributeEditor.js";
import CustomTextAttributeModel from "./CustomTextAttributeModel.js";
import CustomTextAttributeModelCreator from "./CustomTextAttributeModelCreator.js";
import GenericValueRendererPlg from "./GenericCustomTextAttributeRenderer.js";
import StringValueRendererPlg from "./StringCustomTextAttributeRenderer.js";
export default {
  install(plg) {
    plg.addPlugin('CustomTextValueRenderer', StringValueRendererPlg);
    plg.addPlugin('CustomTextValueRenderer', GenericValueRendererPlg);
    plg.addPlugin('CustomTextValueRenderer', ArrayPrimitiveCustomTextAttributeRenderer);
    plg.addPlugin('Model', {
      type: CustomTextAttributeModel.getDetailTypeFor('string'),
      model: CustomTextAttributeModel
    });
    const stringArrayModel = CustomTextAttributeModelCreator.createModel('string*');
    plg.addPlugin('Model', {
      type: stringArrayModel.TYPE,
      model: stringArrayModel
    });
    const intArrayModel = CustomTextAttributeModelCreator.createModel('int*');
    plg.addPlugin('Model', {
      type: intArrayModel.TYPE,
      model: intArrayModel
    });
    const numberArrayModel = CustomTextAttributeModelCreator.createModel('number*');
    plg.addPlugin('Model', {
      type: numberArrayModel.TYPE,
      model: numberArrayModel
    });
    plg.addPlugin('Model', {
      type: CustomTextAttributeModel.TYPE,
      model: CustomTextAttributeModel
    });
    plg.addPlugin('ModelEditor', {
      type: CustomTextAttributeModel.getDetailTypeFor('string'),
      editor: CustomTextAttributeEditor
    });
    plg.addPlugin('ModelEditor', {
      type: CustomTextAttributeModel.TYPE,
      editor: CustomTextAttributeEditor
    });
  }
};